"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostalCodeRegexPatterns = exports.GoogleAnalyticsEventActionNames = exports.GoogleAnalyticsEventName = exports.IndexedLayers = exports.ShippingType = exports.DefineCut = exports.ApiUrl = exports.Default = exports.LocalItems = exports.SessionItems = exports.LanguageToLocale = exports.CurrencyCode = exports.Locale = exports.Country = exports.Language = void 0;
var Language;

(function (Language) {
  Language["en"] = "en";
  Language["fr"] = "fr";
  Language["es"] = "es";
})(Language || (exports.Language = Language = {}));

var Country;

(function (Country) {
  Country["us"] = "us";
  Country["ca"] = "ca";
  Country["mx"] = "mx";
  Country["cn"] = "cn";
})(Country || (exports.Country = Country = {}));

var Locale;

(function (Locale) {
  Locale["us"] = "en-us";
  Locale["ca"] = "en-ca";
  Locale["mx"] = "es-mx";
  Locale["cn"] = "en-us"; // The CN is not supported by Price Util
})(Locale || (exports.Locale = Locale = {}));

var CurrencyCode;

(function (CurrencyCode) {
  CurrencyCode["us"] = "USD";
  CurrencyCode["ca"] = "CAD";
  CurrencyCode["mx"] = "MXN";
  CurrencyCode["cn"] = "USD"; // The CN is not supported by Price Util
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));

var LanguageToLocale;

(function (LanguageToLocale) {
  LanguageToLocale["en"] = "en-us";
  LanguageToLocale["es"] = "es-mx";
  LanguageToLocale["fr"] = "fr-ca";
})(LanguageToLocale || (exports.LanguageToLocale = LanguageToLocale = {}));

var SessionItems;

(function (SessionItems) {
  SessionItems["userFirstName"] = "firstName";
  SessionItems["userLastName"] = "lastName";
  SessionItems["userEmail"] = "email";
  SessionItems["country"] = "country";
  SessionItems["language"] = "language";
  SessionItems["currency"] = "currency";
  SessionItems["localization"] = "localization";
  SessionItems["token"] = "token";
  SessionItems["user"] = "user";
  SessionItems["status"] = "status";
  SessionItems["location"] = "location";
  SessionItems["profile"] = "profile";
  SessionItems["hamburgerActive"] = "hamburgerActive";
  SessionItems["navigationLevel"] = "navigationLevel";
  SessionItems["zipCode"] = "zipCode";
  SessionItems["loginActive"] = "loginActive";
  SessionItems["myAccountActive"] = "myAccountActive";
  SessionItems["swapAccountActive"] = "swapAccountActive";
  SessionItems["myAccountSelectedMenu"] = "myAccountSelectedMenu";
  SessionItems["displaySearchText"] = "displaySearchText";
  SessionItems["barcodeScanResults"] = "barcodeScanResults";
  SessionItems["searchQuote"] = "searchQuote";
  SessionItems["searchOrder"] = "searchOrder";
  SessionItems["customerPickup"] = "customerPickup";
  SessionItems["cartPricingData"] = "cartPricingData";
  SessionItems["shippingAndBillingInformation"] = "shippingAndBillingInformation";
  SessionItems["defaultShipToAddress"] = "defaultShipToAddress";
  SessionItems["shipToAddresses"] = "shipToAddresses";
  SessionItems["searchShippingList"] = "shippingList";
  SessionItems["flexibleDelivery"] = "flexibleDelivery";
  SessionItems["orderConfirmationDetail"] = "orderConfirmationDetail";
  SessionItems["purchaseOrderNumber"] = "purchaseOrderNumber";
  SessionItems["discountCode"] = "discountCode";
  SessionItems["salesPlant"] = "salesPlant";
  SessionItems["isValidZipCode"] = "isValidZipCode";
  SessionItems["isCartDeliverable"] = "isCartDeliverable";
  SessionItems["checkoutType"] = "checkoutType";
  SessionItems["quoteShipToNumber"] = "quoteShipToNumber";
  SessionItems["quoteId"] = "quoteId";
  SessionItems["quoteCart"] = "quoteCart";
  SessionItems["quoteCartPricingData"] = "quoteCartPricingData";
  SessionItems["quoteListForCheckout"] = "quoteListForCheckout";
  SessionItems["quotePurchaseOrderNumber"] = "quotePurchaseOrderNumber";
  SessionItems["bankAccount"] = "bankAccount";
  SessionItems["creditCard"] = "creditCard";
  SessionItems["quoteNameForCheckout"] = "quoteNameForCheckout";
  SessionItems["quoteSourceForCheckout"] = "quoteSourceForCheckout";
  SessionItems["cartDeliveryTimesData"] = "cartDeliveryTimesData";
  SessionItems["shipToAddressPage"] = "shipToAddressPage";
  SessionItems["selectedShipToAddress"] = "selectedShipToAddress";
  SessionItems["quotePaymentInformation"] = "quotePaymentInformation";
  SessionItems["InvoicesTotals"] = "InvoicesTotalsForPayment";
  SessionItems["zipCodeSystemUpdate"] = "zipCodeSystemUpdate";
})(SessionItems || (exports.SessionItems = SessionItems = {}));

var LocalItems;

(function (LocalItems) {
  LocalItems["addToCart"] = "addToCart";
})(LocalItems || (exports.LocalItems = LocalItems = {}));

var Default;

(function (Default) {
  Default["ZIPCODE"] = "60532";
})(Default || (exports.Default = Default = {}));

var ApiUrl;

(function (ApiUrl) {
  ApiUrl["PROFILE"] = "/api/users/v1/protected/profile";
  ApiUrl["ADDRESSES"] = "/api/users/v1/protected/addresses";
  ApiUrl["SWAP_ACCOUNT"] = "/api/users/v1/protected/token/swap-account";
  ApiUrl["LOGIN"] = "/api/users/v1/public/token/auth";
  ApiUrl["REFRESH_TOKEN"] = "/api/users/v1/protected/token/refresh";
  ApiUrl["GLOBAL_SEARCH"] = "/api/items/v1/public/global-search";
  ApiUrl["GLOBAL_SEARCH_V2"] = "/api/items/v2/public/global-search";
  ApiUrl["ADDRESS_GEOCODE"] = "/api/common/v1/public/geocode/address";
  ApiUrl["PRICING_SERVICE"] = "/api/prices/v1/public/pricing";
  ApiUrl["PAYMETRIC_IFRAME"] = "/api/payments/v1/public/paymetric-iframe";
  ApiUrl["PAYMETRIC_RESPONSE"] = "/api/payments/v1/public/paymetric-iframe-response";
  ApiUrl["SHOPPING_LIST"] = "/api/shopping/v1/protected/shopping-lists";
  ApiUrl["SHOPPING_CART"] = "/api/shopping/v1/protected/shopping-cart";
  ApiUrl["ADD_TO_CART"] = "/api/shopping/v1/protected/shopping-cart/items";
  ApiUrl["SALES_PLANT"] = "/api/users/v1/public/user/sales-plant";
  ApiUrl["MAGENIUM_PORTAL"] = "/api/users/v1/protected/transfer/admin-portal";
  ApiUrl["EXIT_SHADOW_MODE"] = "/api/users/v1/protected/transition-mode/normal";
  ApiUrl["GOOGLE_MAPS"] = "https://www.googleapis.com/geolocation/v1/geolocate?key=";
})(ApiUrl || (exports.ApiUrl = ApiUrl = {}));

var DefineCut;

(function (DefineCut) {
  DefineCut["CutIsAllowed"] = "Y";
  DefineCut["CutIsAlwaysRequired"] = "A";
  DefineCut["CutIsNotAllowed"] = "N";
})(DefineCut || (exports.DefineCut = DefineCut = {}));

var ShippingType;

(function (ShippingType) {
  ShippingType["standard"] = "RC";
  ShippingType["customerPickup"] = "WC";
})(ShippingType || (exports.ShippingType = ShippingType = {}));

var IndexedLayers;

(function (IndexedLayers) {
  IndexedLayers[IndexedLayers["base"] = 1] = "base";
  IndexedLayers[IndexedLayers["pageLevel1"] = 100] = "pageLevel1";
  IndexedLayers[IndexedLayers["pageLevel2"] = 200] = "pageLevel2";
  IndexedLayers[IndexedLayers["pageLevel3"] = 300] = "pageLevel3";
  IndexedLayers[IndexedLayers["header"] = 900] = "header";
  IndexedLayers[IndexedLayers["underlay"] = 999] = "underlay";
  IndexedLayers[IndexedLayers["modal"] = 1000] = "modal";
})(IndexedLayers || (exports.IndexedLayers = IndexedLayers = {}));

var GoogleAnalyticsEventName;

(function (GoogleAnalyticsEventName) {
  GoogleAnalyticsEventName["VIEW_CART"] = "view_cart";
  GoogleAnalyticsEventName["ADD_TO_CART"] = "add_to_cart";
  GoogleAnalyticsEventName["REMOVE_FROM_CART"] = "remove_from_cart";
  GoogleAnalyticsEventName["ADD_PAYMENT_INFO"] = "add_payment_info";
  GoogleAnalyticsEventName["PURCHASE"] = "purchase";
  GoogleAnalyticsEventName["BEGIN_CHECKOUT"] = "begin_checkout";
  GoogleAnalyticsEventName["ADD_SHIPPING_INFO"] = "add_shipping_info";
  GoogleAnalyticsEventName["CUT_TO_SIZE"] = "cut_to_size";
  GoogleAnalyticsEventName["NOT_FOUND"] = "not_found";
  GoogleAnalyticsEventName["ITEM_SEARCH"] = "item_search";
  GoogleAnalyticsEventName["QUOTE"] = "quote";
  GoogleAnalyticsEventName["CONTACT_US"] = "contact_us";
  GoogleAnalyticsEventName["STAY_TUNED"] = "stay_tuned";
  GoogleAnalyticsEventName["LOCATION_CONTACT_US"] = "location_contact_us";
  GoogleAnalyticsEventName["SIGN_UP"] = "sign_up";
  GoogleAnalyticsEventName["STOCK_LIST"] = "stock_list";
})(GoogleAnalyticsEventName || (exports.GoogleAnalyticsEventName = GoogleAnalyticsEventName = {}));

var GoogleAnalyticsEventActionNames;

(function (GoogleAnalyticsEventActionNames) {
  GoogleAnalyticsEventActionNames["DOWNLOAD"] = "download";
  GoogleAnalyticsEventActionNames["PURCHASE"] = "purchase";
  GoogleAnalyticsEventActionNames["SUBMIT"] = "submit";
  GoogleAnalyticsEventActionNames["KNOW"] = "know";
  GoogleAnalyticsEventActionNames["BROWSE"] = "browse";
  GoogleAnalyticsEventActionNames["EDIT"] = "edit";
  GoogleAnalyticsEventActionNames["ORDER"] = "order";
  GoogleAnalyticsEventActionNames["REMOVE"] = "remove";
  GoogleAnalyticsEventActionNames["CREATE"] = "create";
  GoogleAnalyticsEventActionNames["OPEN"] = "open";
  GoogleAnalyticsEventActionNames["APPLY"] = "apply";
  GoogleAnalyticsEventActionNames["CLOSE"] = "close";
})(GoogleAnalyticsEventActionNames || (exports.GoogleAnalyticsEventActionNames = GoogleAnalyticsEventActionNames = {}));
/**
 * Postal code regex patterns for US, CA and MX
 * See country post code formats: https://gist.github.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b
 */


var PostalCodeRegexPatterns;

(function (PostalCodeRegexPatterns) {
  PostalCodeRegexPatterns["us"] = "^\\b\\d{5}\\b(?:[- ]{1}\\d{4})?$";
  PostalCodeRegexPatterns["usaStandardZipCode"] = "^\\d{5}$";
  PostalCodeRegexPatterns["mx"] = "^\\d{5}$";
  PostalCodeRegexPatterns["ca"] = "^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$";
  PostalCodeRegexPatterns["whiteSpace"] = "/^s+|s+$/g";
})(PostalCodeRegexPatterns || (exports.PostalCodeRegexPatterns = PostalCodeRegexPatterns = {}));